import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { MgmtDept, isMgmtDept } from '../models/mgmt-dept.model';
import { DistinctSubject } from '../models/utility.model';
import { AuthUsecase } from '../usecases/auth.usecase';
import { MgmtDeptGateway } from '../usecases/mgmt-dept.gateway';
import { MgmtDeptUsecase } from '../usecases/mgmt-dept.usecase';

@Injectable()
export class MgmtDeptInteractor extends MgmtDeptUsecase {
  get mgmtDept$(): Observable<MgmtDept> {
    return this._mgmtDept.pipe(filter(isMgmtDept));
  }

  private readonly _mgmtDept = new DistinctSubject<MgmtDept | undefined>(undefined);

  constructor(
    private _authUsecase: AuthUsecase,
    private _mgmtDeptGateway: MgmtDeptGateway,
  ) {
    super();
    this._authUsecase.authState$.subscribe(({ status }) => {
      switch (status) {
        case 'signedIn':
          this.onSignIn();
          break;
        case 'signIn':
          this.onSignOut();
          break;
        default:
          // nop
          break;
      }
    });
  }

  private onSignIn(): void {
    this._authUsecase.payload$
      .pipe(mergeMap(({ mgmtDeptId }) => this._mgmtDeptGateway.getMgmtDept(mgmtDeptId || '')))
      .subscribe(mgmtDept => this._mgmtDept.next(mgmtDept));
  }

  private onSignOut(): void {
    this._mgmtDept.next(undefined);
  }
}
